import type { LucideIcon } from 'lucide-react';
import type { ReactElement, ReactNode } from 'react';

interface ClaimStatusViewProps {
  icon: LucideIcon;
  iconClassName?: string;
  title: string;
  description?: string;
  /** Optional CTA rendered below the description */
  action?: ReactNode;
}

/**
 * Centered icon/title/description status layout shared by the loading,
 * invalid-token, success, and error states on the claim-verify page.
 *
 * Consolidates the four near-identical `<div className='container ...'>`
 * blocks that lived inline in the old page.tsx.
 */
export function ClaimStatusView({
  icon: Icon,
  iconClassName = 'h-12 w-12 mb-4',
  title,
  description,
  action,
}: ClaimStatusViewProps): ReactElement {
  return (
    <div className='container mx-auto px-4 py-16 flex flex-col items-center justify-center min-h-[60vh]'>
      <Icon className={iconClassName} />
      <h1 className='text-xl font-semibold mb-2 text-center'>{title}</h1>
      {description ? (
        <p className='text-muted-foreground mb-6 text-center max-w-md'>
          {description}
        </p>
      ) : null}
      {action}
    </div>
  );
}
